import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import CollectionLabel from '@/collections/components/CollectionLabel';

const listItems = (collections) => collections.map((collection) => ({
  key: `collection_dropdown_item_${collection.code}`,
  text: collection.name,
  value: collection.code,
  content: (
    <CollectionLabel collection={collection} asLink={false} />
  ),
}));

const DatasetCollectionsDropdown = ({
  filter,
  collections,
  disabled,
  autoFocus,
  className,
  text,
  onChange,
  onFilterChange,
  readStatus,
}) => {
  const intl = useIntl();
  const renderLabel = (label) => {
    const collection = {
      name: label.text,
      code: label.value,
    };
    return <CollectionLabel collection={collection} showLogo asLink={false} />;
  };

  return (
    <Dropdown
      placeholder={intl.formatMessage({ id: 'find.collections.placeholder' })}
      options={listItems(collections)}
      fluid
      search={(options) => options}
      searchQuery={filter}
      selection
      multiple
      autoFocus={autoFocus}
      disabled={disabled}
      size="large"
      className={clsx('aridhia-dataset-collections-dropdown mt-0', className)}
      value={text}
      onSearchChange={
        (e, { searchQuery }) => { onFilterChange(searchQuery); }
      }
      onChange={(e, { value }) => { onChange(value); }}
      loading={readStatus === states.PENDING}
      noResultsMessage={intl.formatMessage({ id: 'find.collections.none' })}
      renderLabel={renderLabel}
    />
  );
};

export default DatasetCollectionsDropdown;
